import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-3995ea91"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modern-form-container" };
const _hoisted_2 = { class: "form-card" };
const _hoisted_3 = { class: "card-header" };
const _hoisted_4 = /*#__PURE__*/ _createStaticVNode("<div class=\"header-icon\" data-v-3995ea91><svg width=\"32\" height=\"32\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-3995ea91><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\" data-v-3995ea91></path><polyline points=\"14,2 14,8 20,8\" data-v-3995ea91></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-3995ea91></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-3995ea91></line><polyline points=\"10,9 9,9 8,9\" data-v-3995ea91></polyline></svg></div>", 1);
const _hoisted_5 = { class: "form-title" };
const _hoisted_6 = { class: "card-body" };
const _hoisted_7 = { class: "terms-container" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = { class: "scroll-indicator" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2"
}, [
    /*#__PURE__*/ _createElementVNode("path", { d: "M6 9l6 6 6-6" })
], -1));
const _hoisted_11 = { class: "acceptance-section" };
const _hoisted_12 = { class: "checkbox-container" };
const _hoisted_13 = { class: "custom-checkbox" };
const _hoisted_14 = { class: "checkbox-custom" };
const _hoisted_15 = {
    key: 0,
    width: "14",
    height: "14",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "3",
    class: "check-icon"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("polyline", { points: "20,6 9,17 4,12" }, null, -1));
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { class: "checkbox-label" };
const _hoisted_19 = {
    key: 0,
    class: "acceptance-status"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "status-icon" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2"
    }, [
        /*#__PURE__*/ _createElementVNode("polyline", { points: "20,6 9,17 4,12" })
    ])
], -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Conditions acceptées", -1));
const _hoisted_22 = [
    _hoisted_20,
    _hoisted_21
];
const _hoisted_23 = {
    key: 0,
    class: "banner-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_banner = _resolveComponent("hit-banner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.terms_and_conditions_of_use')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                        class: "terms-content",
                        innerHTML: _ctx.termsAndConditions
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.scroll_to_read_the_full_terms_and_conditions')), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                                id: "checkbox",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.checked) = $event)),
                                type: "checkbox",
                                class: "checkbox-input"
                            }, null, 512), [
                                [_vModelCheckbox, _ctx.checked]
                            ]),
                            _createElementVNode("span", _hoisted_14, [
                                (_ctx.checked)
                                    ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _hoisted_17))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.t('admin-ui.text_accept_agreement')), 1)
                        ])
                    ]),
                    (_ctx.checked)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
                        : _createCommentVNode("", true)
                ])
            ])
        ]),
        (_ctx.showBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_hit_banner, {
                    "show-animation": _ctx.showAnimationBanner,
                    onClose: _cache[1] || (_cache[1] = ($event) => (_ctx.closeBanner()))
                }, {
                    "dynamic-content": _withCtx(() => [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.textBanner), 1)
                    ]),
                    _: 1
                }, 8, ["show-animation"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
